import { useLayoutEffect, useRef, useState, type CSSProperties } from 'react';

// Auto-scrolls (bounces side to side) a name too long for its row, so the
// full signal/channel name is readable without the user doing anything -
// used only for the one legend/detail row that's actually
// selected/highlighted at a time (see SignalActivityChart), so the rest of
// the list stays still rather than turning into a wall of moving text.
// Falls back to plain truncation (`active` false, or the text already
// fits) so this never moves anything the user didn't pick.
export function MarqueeText({ text, active, className = '' }: { text: string; active: boolean; className?: string }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);
  const [distance, setDistance] = useState(0);

  useLayoutEffect(() => {
    if (!active || !containerRef.current || !textRef.current) {
      setDistance(0);
      return;
    }
    const overflow = textRef.current.scrollWidth - containerRef.current.clientWidth;
    setDistance(overflow > 2 ? overflow : 0);
  }, [active, text]);

  return (
    <div ref={containerRef} className={`overflow-hidden whitespace-nowrap ${className}`}>
      <span
        ref={textRef}
        className="inline-block"
        style={
          distance > 0
            ? ({ animation: 'chart-marquee 5s ease-in-out infinite', '--marquee-distance': `-${distance}px` } as CSSProperties)
            : undefined
        }
      >
        {text}
      </span>
    </div>
  );
}
